import {useEffect, useRef} from 'react'

export const useTitle = (title: string): void => {
  const documentDefined = typeof document !== 'undefined'
  const originalTitle = useRef(documentDefined ? document.title : null)

  useEffect(() => {
    if (!documentDefined) return

    if (window.document.title !== title) window.document.title = title

    return () => {
      window.document.title = originalTitle.current || window.document.title
    }
  }, [documentDefined, title])
}

export const useMetaDescription = (description: string): void => {
  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]')

    if (metaDescription) {
      metaDescription.setAttribute('content', description)
    }
  }, [description])
}


export const useCanonicalLink = (href: string): void => {
  useEffect(() => {
    const canonicalLink = document.querySelector('link[rel="canonical"]')

    if (canonicalLink) {
      canonicalLink.setAttribute('href', href)
    }
  }, [href])
}